export default __webpack_public_path__ + "static/media/3.017f06c9.png";